    //mileage scroll directive main function
    var mileageScrollController = function ($scope, $element, $attrs) {
        
        $scope.scrollToInterval = function (el) {
            //calculate the position that is required to scroll to
            var center = angular.element($element)[0].offsetWidth / 2;
            var elOffset = el.offsetLeft;
            var centerElOffset = elOffset + el.clientWidth / 2;
            if (centerElOffset > center) {
                offset = centerElOffset - center;
            } else {
                offset = 0;
            }
            angular.element($element)[0].scrollLeft = offset;
        };

    };
    //mileage scroll main function injections
    mileageScrollController.$inject = ['$scope', '$element', '$attrs'];

    angular.module('OSS').directive('mileageScroll', function () {
        return {
            restrict: 'A',
            controller: mileageScrollController
        }
    });

    //mileage scroll item directive main function
    var mileageScrollItemController = function ($scope, $element, $attrs, $timeout) {
        var currentElement = $element[0] ? $element[0] : undefined;
        
        if ($scope.interval && $scope.interval.selected) {
            $timeout(function () {
                $scope.scrollToInterval(currentElement);
            }, 0);
        }

        $scope.onSelectInterval = function (interval) {
            $scope.scrollToInterval(currentElement);
            $scope.setSelectedInterval(interval);
        };
    };

    //mileage scroll item function injections   
    mileageScrollItemController.$inject = ['$scope', '$element', '$attrs', '$timeout'];

    module.exports = function () {
        return {
            restrict: 'A',
            controller: mileageScrollItemController
        }
    }